import React, { useEffect, useState } from "react";
import AccountDetail from "./AccountDetail";
import ChartComp from "./ChartComp";

export default function UserDashboardIndex() {
  const [userDetails, setUserDetails] = useState({
    subscriptionDetails: {
      isSubscribe: false,
      duration: "0",
      expires: "",
    },
    startBalance: 0,
    currentBalance: 0,
  });

  useEffect(() => {
    const storedDetails = localStorage.getItem("userDetails");
    if (storedDetails) {
      setUserDetails(JSON.parse(storedDetails));
    }
  }, []);

  return (
    <div>
      <div>
        <p className="font-extrabold text-4xl mt-3">
          {userDetails.subscriptionDetails.isSubscribe ? "Real" : "Demo"}
        </p>
        <div className="flex justify-between py-10 flex-col lg:flex-row lg:gap-0 gap-4">
          <span>
            <p className="mb-3">Exchange Information</p>
            <p className="mb-3">Platform: Binance</p>
            <p className="mb-3">Broker: ******</p>
            <p>
              Type:{" "}
              {userDetails.subscriptionDetails.isSubscribe ? "Real" : "Demo"}
            </p>
          </span>
          <AccountDetail
            name={"Initial Balance"}
            amount={`${userDetails.startBalance}`}
          />
          <AccountDetail
            name={"Total Profit"}
            amount={
              userDetails.currentBalance === 0
                ? "0"
                : `${userDetails.currentBalance - userDetails.startBalance}`
            }
            percent={"99.712 %"}
          />
          <AccountDetail
            name={"This Month"}
            amount={
              userDetails.currentBalance === 0
                ? "0"
                : `${userDetails.currentBalance - userDetails.startBalance}`
            }
            percent={"99.712 %"}
          />
          <AccountDetail
            name={"This Week"}
            amount={
              userDetails.currentBalance === 0
                ? "0"
                : `${userDetails.currentBalance - userDetails.startBalance}`
            }
            percent={"99.712 %"}
          />
          <AccountDetail
            name={"Today"}
            amount={
              userDetails.currentBalance === 0
                ? "0"
                : `${userDetails.currentBalance - userDetails.startBalance}`
            }
            percent={"99.712 %"}
          />
        </div>
      </div>
      <div className="">
        <h2 className="font-bold text-xl ">Performance</h2>
        <ChartComp />
      </div>
    </div>
  );
}
